/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.saleForecast.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/saleForecast/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
